import type { Token } from "@frend-digital/centra-types";
import type { BaseSelectionResponse } from "@frend-digital/centra-types/selection";
import { useMutation, type UseMutationOptions } from "@tanstack/react-query";
import { selectionChange } from "../../../checkout/actions";
import {
  useCheckoutContext,
  useCheckoutDispatch,
} from "../../../checkout/selectors";
import { updateShippingMethod } from "../fetchers";

export const updateShippingMethodOptions = ({
  token,
  apiUrl,
}: {
  token: Token;
  apiUrl: string;
}) => ({
  mutationKey: ["shipping-methods", token],
  mutationFn: async (shippingMethod: string) => {
    const result = await updateShippingMethod({
      shippingMethod,
      token,
      apiUrl,
    });

    return result.unwrap();
  },
});

interface ShippingMethodProps {
  onSuccess?: UseMutationOptions<
    BaseSelectionResponse,
    Error,
    string
  >["onSuccess"];
}

export function useUpdateShippingMethod({
  onSuccess,
}: ShippingMethodProps = {}) {
  const { centraUrl, token } = useCheckoutContext();
  const dispatch = useCheckoutDispatch();

  return useMutation({
    ...updateShippingMethodOptions({ token, apiUrl: centraUrl }),
    onSuccess: (...args) => {
      const [selection] = args;
      // Dispatch selection change
      dispatch(selectionChange(selection, "shipping_method"));

      onSuccess?.(...args);
    },
  });
}
